import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const SEO: FunctionComponent<{ page: string }> = ({ page }) => {
  const { messages } = useIntl();
  return (
    <Helmet title={`${messages[`${page}.meta.title`]}`}>
      <meta
        name="description"
        content={`${messages[`${page}.meta.description`]}`}
      />
      {messages[`${page}.meta.keywords`] && (
        <meta
          name="keywords"
          content={`${messages[`${page}.meta.keywords`]}`}
        />
      )}
      <meta property="og:title" content={`${messages[`${page}.meta.title`]}`} />
      <meta
        property="og:description"
        content={`${messages[`${page}.meta.description`]}`}
      />
      <meta
        property="og:site_name"
        content={`${messages[`${page}.meta.site`]}`}
      />
      <meta
        property="og:image"
        content={`https://verse.bitcoin.com${messages[`${page}.meta.image`]}`}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:site"
        content={`@${messages[`${page}.meta.twitter`]}`}
      />
      <meta
        name="twitter:title"
        content={`${messages[`${page}.meta.title`]}`}
      />
      <meta
        name="twitter:description"
        content={`${messages[`${page}.meta.description`]}`}
      />
      <meta
        name="twitter:image"
        content={`https://verse.bitcoin.com${messages[`${page}.meta.image`]}`}
      />
      <link rel="canonical" href="https://verse.bitcoin.com" />
    </Helmet>
  );
};

export default SEO;
